import { request } from '@/utils/index';

const vendorURI = '/hk/dd/v2';
const vendorTeaserURI = '/hk/dd/v2/teaser';

interface vehicleTeaserParams {
  vin?: string;
  licensePlate?: string;
  state?: string;
  year?: string;
  make?: string;
  model?: string;
  trim?: string;
}

export const getSchoolSearchData = async (schoolId: string) => {
  const URL = `${vendorURI}/school?id=${schoolId}`;

  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

export const vehicleSelections = async () => {
  const URL = `${vendorURI}/selections`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

export const vehicleTeaser = async (params: vehicleTeaserParams) => {
  if (params.vin) {
    return vehicleVINTeaser(params.vin);
  }
  if (params.licensePlate && params.state) {
    return vehiclePlateTeaser(params.licensePlate, params.state);
  }
  if (params.year && params.make && params.model) {
    return vehicleYMMTeaser(
      params.year,
      params.make,
      params.model,
      params.trim || ''
    );
  }
};

const vehicleVINTeaser = async (vin: string) => {
  const URL = `${vendorTeaserURI}/vin?vin=${vin}`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

const vehiclePlateTeaser = async (licensePlate: string, state: string) => {
  const URL = `${vendorTeaserURI}/vin?license_plate=${licensePlate}&state=${state}`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

const vehicleYMMTeaser = async (
  year: string,
  make: string,
  model: string,
  trim: string
) => {
  const URL = `${vendorTeaserURI}/vin?year=${year}&make=${make}&model=${model}&trim=${trim}`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

export const vehicleComplaints = async (
  year: string,
  make: string,
  model: string
) => {
  const URL = `${vendorURI}/complaints?year=${year}&make=${make}&model=${model}`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};

export const statesContact = async () => {
  const URL = `${vendorURI}/statescontact`;
  return await request(URL, {
    headers: new Headers({
      'content-type': 'application/x-www-form-urlencoded',
    }),
    method: 'GET',
  });
};
